export const cardSizesAreValid = (smallCardSize: number, mediumCardSize: number, mapCardSize: number) => {
    return smallCardSize >= 0 && mediumCardSize >= 0 && mapCardSize >= 0
            && Math.abs(smallCardSize + mediumCardSize + mapCardSize - 100) < 0.001;
}

// PanelGroup.setLayout asserts the left-to-right sum is exactly 100 (strict ===, no
// epsilon), which fractional drag sizes fail on FP rounding. Absorb the dust into the
// last (map) panel until the sum the library computes is exact.
export const normalizePanelSizes = (sizes: number[]): number[] => {
    const result = [...sizes];
    const last = result.length - 1;
    for (let i = 0; i < 10; i++) {
        const total = result.reduce((accumulated, current) => accumulated + current, 0);
        if (total === 100) {
            return result;
        }
        result[last] += 100 - total;
    }
    const rounded = result.map(Math.round);
    rounded[last] = 100 - rounded.slice(0, last).reduce((accumulated, current) => accumulated + current, 0);
    return rounded;
}

export const resolveVisibleCardSizes = ({
    smallCardSize,
    mediumCardSize,
    mapCardSize,
    defaultSmallCardSize,
    defaultMediumCardSize,
    smallIsVisible,
    mediumIsVisible,
}: {
    smallCardSize: number;
    mediumCardSize: number;
    mapCardSize: number;
    defaultSmallCardSize: number;
    defaultMediumCardSize: number;
    smallIsVisible: boolean;
    mediumIsVisible: boolean;
}) => {
    const canReuseLayout = cardSizesAreValid(smallCardSize, mediumCardSize, mapCardSize)
        && (!smallIsVisible || smallCardSize > 0)
        && (!mediumIsVisible || mediumCardSize > 0);
    const resolvedSmallCardSize = smallIsVisible
        ? canReuseLayout ? smallCardSize : defaultSmallCardSize
        : 0;
    const resolvedMediumCardSize = mediumIsVisible
        ? canReuseLayout ? mediumCardSize : defaultMediumCardSize
        : 0;

    return {
        smallCardSize: resolvedSmallCardSize,
        mediumCardSize: resolvedMediumCardSize,
        mapCardSize: 100 - resolvedSmallCardSize - resolvedMediumCardSize,
    };
};
